import {SpendModeEventChooseI, SpendModeEventI} from "../../../spendMode/config/SpendInterface";
import spendGameManager from "../../../spendMode/manager/spendGameManager";
import O1HD from "../../../../engines/gameEngine";
import getOneSpendEventById from "../../../spendMode/config/SpendEventConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class spendEventShow extends cc.Component {

    @property({type:cc.Label,displayName:"事件NPC文本"})
    lb_NpcName:cc.Label = null;

    @property({type:cc.Node,displayName:"选择节点"})
    chooseNode:cc.Node = null;

    @property({type:cc.Sprite,displayName:"icon图片"})
    sp_icon:cc.Sprite = null;

    @property({type:cc.Sprite,displayName:"bg节点"})
    bgNode:cc.Sprite = null;

    @property({type:cc.Label,displayName:"描述文本"})
    lb_Dec:cc.Label = null;

    @property({type:cc.ScrollView,displayName:"文本scoll"})
    scoll:cc.ScrollView = null;
    @property({type:cc.ScrollView,displayName:"自己文本scoll"})
    meScoll:cc.ScrollView = null;

    @property({type:cc.Node,displayName:"中心节点"})
    centerNode:cc.Node = null;

    @property({type:cc.Node,displayName:"自己说话的节点"})
    meCenterNode:cc.Node = null;

    @property({type:cc.Label,displayName:"自己说话文本"})
    meLabel:cc.Label = null;

    @property({type:cc.Node,displayName:"dialogSp节点"})
    dialogSp:cc.Sprite = null;

    completeFun:( eventEnd : number )=>void = null;

    event:SpendModeEventI = null;

    canClick:boolean = false;
    mGameLayer : spendGameManager;
    eventEnd : number = 0;

    bindEvent(event:SpendModeEventI , gameLayer : spendGameManager ,complete?:( eventEnd : number )=>void){
        this.event = event;
        this.mGameLayer = gameLayer;
        this.completeFun = complete;
        this.updateDialog();
    }

    protected onLoad(): void {
        // this.event = getOneSpendEventById(4);
        // this.updateDialog();
    }

    updateDialog(){
        this.meCenterNode.active = false;
        let name:string = this.event.belongNpc;
        this.lb_NpcName.string = name;
        let spIcon:string = this.event.belongNpc;
        this.centerNode.active = true;
        //测试的时候将icon置空  后续需注释掉
        // spIcon = null;
        if(spIcon!=null){
            this.sp_icon.spriteFrame = null;
            this.sp_icon.node.active = true;
        }else{
            this.sp_icon.spriteFrame = null;
        }

        this.dialogSp.spriteFrame = null;
        this.sp_icon.node.active = true;
        this.lb_Dec.string = "";
        this.centerNode.scale = 0;
        this.chooseNode.children.forEach((n:cc.Node)=>{
            n.active = false;
        });

        cc.tween(this.centerNode).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
        this.scheduleOnce(this.updateChoose,.5);
    }

    async updateChoose(){
        let chooseData:SpendModeEventChooseI[] = this.event.chooseArr;
        console.log(chooseData,"chooseData");
        await this.aiAsk();
        if(chooseData){
            for(let i = 0;i<chooseData.length;i++){
                let node:cc.Node = this.chooseNode.children[i];
                node.active = true;
                node.getChildByName("lb").getComponent(cc.Label).string = this.event.chooseArr[i].name;
            }
        }else{
            this.event.chooseArr = [
                {name:"知道了"}
            ];
            let chooseNode:cc.Node = this.chooseNode.children[0];
            chooseNode.active = true;
            chooseNode.getChildByName("lb").getComponent(cc.Label).string = this.event.chooseArr[0].name;
        }
    }

    async onBtnChoose(e:cc.Event.EventTouch,custom:string){
        let chooseData:SpendModeEventChooseI = null;
        switch(custom){
            case "0":{
                chooseData = this.event.chooseArr[0];
                break;
            }
            case "1":{
                chooseData = this.event.chooseArr[1];
                break;
            }
        }
        this.chooseNode.children.forEach((n:cc.Node)=>{
            n.active = false;
        });
        await this.meAsk(chooseData);
        if(chooseData.nextEventId!= null){
            await this.closeAni();
            this.bindEvent( getOneSpendEventById(chooseData.nextEventId), this.mGameLayer , this.completeFun );
        }else{
            this.closeThis();
        }
    }

    //点击跳过按钮
    onClickBlockNode(){
        this.isBreak = true;
        this.hideBlockNode();
    }

    showBlockNode(){
        this.blockNode.active = true;
    }

    hideBlockNode(){
        this.blockNode.active = false;
    }

    isBreak:boolean = false;

    @property({type:cc.Node,displayName:"跳过节点"})
    blockNode:cc.Node = null;
    //自己讲话
    async meAsk(chooseData:SpendModeEventChooseI){
        return new Promise<void>(async resolve=>{
            let meAsk:string = chooseData.meAsk;
            if(meAsk!=null){
                //
                this.isBreak = false;
                this.showBlockNode();
                this.centerNode.active = false;
                this.meCenterNode.active = true;
                this.meCenterNode.scale = 1;
                this.meLabel.string = "";
                a : for(let i =0;i<meAsk.length;i++){
                    let s = meAsk[i];
                    this.meLabel.string += s;
                    await new Promise<void>(resolve=>{
                        this.scheduleOnce(resolve,.05);
                        this.meScoll.scrollToBottom(.05);
                    });
                    console.log("自己讲话");
                    if(this.isBreak){
                        this.meLabel.string = meAsk;
                        this.scheduleOnce(()=>{
                            this.meScoll.scrollToBottom(.05);
                        },.05);
                        break a;
                    }
                }
                this.hideBlockNode();
                this.scheduleOnce(()=>{
                    resolve();
                },1)
            }else{
                this.hideBlockNode();
                this.scheduleOnce(()=>{
                    resolve();
                },1);
            }
        });
    }
    //ai说话
    async aiAsk(){
        return new Promise<void>(async resolve=>{
            this.isBreak = false;
            this.showBlockNode();
            let dec:string = this.event.dec;
            a : for(let i =0;i<dec.length;i++){
                let s = dec[i];
                this.lb_Dec.string += s;
                await new Promise<void>(resolve=>{
                    this.scheduleOnce(resolve,.05);
                    this.scoll.scrollToBottom(.05);
                });
                console.log("AI讲话");
                if(this.isBreak){
                    this.lb_Dec.string = dec;
                    this.scheduleOnce(()=>{
                        this.scoll.scrollToBottom(.05);
                    },.05);
                    break a;
                }
            }
            this.hideBlockNode();
            resolve();
        });
    }

    closeAni(){
        return new Promise<void>(resolve=>{
            cc.tween(this.centerNode).to(.5,{scale:0},{easing:cc.easing.backIn}).start();
            cc.tween(this.meCenterNode).to(.5,{scale:0},{easing:cc.easing.backIn}).start();
            this.hideBlockNode();
            this.scheduleOnce(resolve,.5);
        });
    }

    /**
     * 返回按钮
     */
    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeThis().then();
    }

    //关闭
    async closeThis(){
        await this.closeAni()
        this.completeFun && this.completeFun( this.eventEnd );
        this.node.destroy();
        this.node.removeFromParent();
    }

}
